/* Translation of locales/en-US/packs.ts (generated from lib/industryPacks/catalog.ts). Same keys;
 * only the values are translated. */
export const packs = {
  "property": {
    "assetTypes": {
      "0": "Casa",
      "1": "Apartamento",
      "2": "Oficina",
      "3": "Caldera",
      "4": "Instalación eléctrica",
      "5": "Equipos contra incendios",
      "6": "Electrodoméstico"
    },
    "sample": {
      "name": "Inmueble de ejemplo",
      "description": "Un inmueble de ejemplo para que pruebe una inspección antes de añadir los suyos."
    },
    "templates": {
      "condition_inspection": {
        "name": "Inspección del estado del inmueble",
        "description": "Recorra el inmueble y registre su estado estancia por estancia.",
        "items": {
          "0": {
            "label": "Estado del exterior y de la parcela"
          },
          "1": {
            "label": "Cubierta, canalones y bajantes"
          },
          "2": {
            "label": "Ventanas y puertas exteriores"
          },
          "3": {
            "label": "Humedad, moho o daños por agua",
            "description": "Responda sí si hay alguno."
          },
          "4": {
            "label": "Calefacción y agua caliente funcionan"
          },
          "5": {
            "label": "Estado interior general"
          }
        }
      },
      "room_inspection": {
        "name": "Inspección de estancia",
        "description": "Una sola estancia, con el detalle suficiente para resolver una disputa más adelante.",
        "groups": {
          "0": {
            "label": "Estado de la estancia",
            "guidance": "Escanee las paredes, el techo, el suelo y las ventanas. Muestre el detector de humo si lo hay."
          },
          "1": {
            "label": "Instalaciones y accesorios"
          }
        },
        "items": {
          "0": {
            "label": "Paredes y techo"
          },
          "1": {
            "label": "Revestimiento del suelo"
          },
          "2": {
            "label": "Ventana y acristalamiento"
          },
          "3": {
            "label": "Detector de humo presente"
          },
          "4": {
            "label": "Enchufes, interruptores e iluminación"
          },
          "5": {
            "label": "Elementos fijos y accesorios"
          },
          "6": {
            "label": "Limpieza"
          }
        }
      },
      "move_in_out": {
        "name": "Entrada / salida de inquilinos",
        "description": "El registro que ambas partes aceptan en la entrega.",
        "items": {
          "0": {
            "label": "Lecturas de contadores registradas"
          },
          "1": {
            "label": "Llaves entregadas y contadas"
          },
          "2": {
            "label": "Detectores de humo y CO probados"
          },
          "3": {
            "label": "Limpieza general"
          },
          "4": {
            "label": "Daños existentes fotografiados"
          },
          "5": {
            "label": "Electrodomésticos presentes y funcionando"
          }
        }
      },
      "fire_safety_check": {
        "name": "Revisión de seguridad contra incendios",
        "description": "Alarmas, vías de evacuación y equipos. Evidencias, no una opinión jurídica.",
        "items": {
          "0": {
            "label": "Detectores de humo presentes y suenan"
          },
          "1": {
            "label": "Detector de monóxido de carbono presente y suena"
          },
          "2": {
            "label": "Vías de evacuación despejadas"
          },
          "3": {
            "label": "Las puertas cortafuegos cierran del todo"
          },
          "4": {
            "label": "Extintores en vigor"
          },
          "5": {
            "label": "Alumbrado de emergencia funciona"
          }
        }
      },
      "maintenance_walkthrough": {
        "name": "Recorrido de mantenimiento general",
        "description": "La revisión rutinaria que detecta los problemas mientras son pequeños.",
        "items": {
          "0": {
            "label": "Fontanería y fugas visibles"
          },
          "1": {
            "label": "Estado del sistema de calefacción"
          },
          "2": {
            "label": "Electricidad y cableado visible"
          },
          "3": {
            "label": "Puertas, cerraduras y seguridad"
          },
          "4": {
            "label": "Zonas exteriores y drenaje"
          }
        }
      }
    },
    "maintenance": {
      "boiler_annual_service": {
        "title": "Revisión anual de la caldera",
        "description": "Revise la caldera y mantenga al día el registro de seguridad del gas."
      },
      "fire_safety_quarterly": {
        "title": "Revisión trimestral de seguridad contra incendios",
        "description": "Alarmas, vías de evacuación y equipos."
      }
    },
    "compliance": {
      "gas_safety": {
        "label": "Registro de seguridad del gas"
      },
      "eicr": {
        "label": "Informe del estado de la instalación eléctrica (EICR)"
      },
      "fire_safety": {
        "label": "Evidencias de seguridad contra incendios, incluidos los detectores de humo y CO"
      }
    }
  },
  "fleet": {
    "assetTypes": {
      "0": "Coche",
      "1": "Furgoneta",
      "2": "Camión",
      "3": "Remolque"
    },
    "sample": {
      "name": "Furgoneta de ejemplo",
      "description": "Un vehículo de ejemplo para que pruebe una revisión diaria antes de añadir los suyos."
    },
    "templates": {
      "daily_vehicle_check": {
        "name": "Revisión diaria del vehículo",
        "description": "La vuelta de inspección antes de mover el vehículo.",
        "items": {
          "0": {
            "label": "Luces e intermitentes"
          },
          "1": {
            "label": "Neumáticos y presiones"
          },
          "2": {
            "label": "Los frenos responden con normalidad"
          },
          "3": {
            "label": "Retrovisores y cristales"
          },
          "4": {
            "label": "Niveles de líquidos"
          },
          "5": {
            "label": "Testigos encendidos en el salpicadero",
            "description": "Responda sí si hay alguno encendido."
          },
          "6": {
            "label": "Carga asegurada"
          }
        }
      },
      "vehicle_condition": {
        "name": "Estado del vehículo",
        "description": "El registro completo del estado, de la carrocería al interior.",
        "groups": {
          "0": {
            "label": "Exterior del vehículo",
            "guidance": "Rodee el vehículo. Muestre cada lado, las luces, los cristales y los neumáticos."
          },
          "1": {
            "label": "Interior del vehículo",
            "guidance": "Muestre los asientos, el salpicadero y el cuentakilómetros."
          },
          "2": {
            "label": "Documentación"
          }
        },
        "items": {
          "0": {
            "label": "Estado de la carrocería"
          },
          "1": {
            "label": "Profundidad del dibujo de los neumáticos aceptable"
          },
          "2": {
            "label": "Cristales y retrovisores"
          },
          "3": {
            "label": "Luces intactas"
          },
          "4": {
            "label": "Estado del interior"
          },
          "5": {
            "label": "Lectura del cuentakilómetros"
          },
          "6": {
            "label": "Historial de mantenimiento al día"
          }
        }
      },
      "damage_inspection": {
        "name": "Inspección de daños",
        "description": "Qué ocurrió, dónde y qué aspecto tiene.",
        "items": {
          "0": {
            "label": "Daños fotografiados desde todos los lados"
          },
          "1": {
            "label": "El vehículo sigue apto para circular"
          },
          "2": {
            "label": "Paneles y carrocería"
          },
          "3": {
            "label": "Cristales y luces intactos"
          },
          "4": {
            "label": "Hay terceros implicados"
          }
        }
      },
      "handover": {
        "name": "Entrega del vehículo",
        "description": "El estado y el contenido en el momento en que las llaves cambian de manos.",
        "items": {
          "0": {
            "label": "Lectura del cuentakilómetros registrada"
          },
          "1": {
            "label": "Nivel de combustible o de carga registrado"
          },
          "2": {
            "label": "Llaves y documentos entregados"
          },
          "3": {
            "label": "Daños existentes registrados"
          },
          "4": {
            "label": "Limpieza"
          }
        }
      },
      "tyres": {
        "name": "Revisión de neumáticos",
        "description": "Dibujo, presión y estado, rueda por rueda.",
        "items": {
          "0": {
            "label": "Delantera izquierda"
          },
          "1": {
            "label": "Delantera derecha"
          },
          "2": {
            "label": "Trasera izquierda"
          },
          "3": {
            "label": "Trasera derecha"
          },
          "4": {
            "label": "Rueda de repuesto o kit de reparación presente"
          }
        }
      },
      "service_check": {
        "name": "Revisión de mantenimiento",
        "description": "Lo que revisó el taller y lo que encontró.",
        "items": {
          "0": {
            "label": "Lectura del cuentakilómetros registrada"
          },
          "1": {
            "label": "Aceite y filtro cambiados"
          },
          "2": {
            "label": "Frenos inspeccionados"
          },
          "3": {
            "label": "Suspensión y dirección"
          },
          "4": {
            "label": "Códigos de avería leídos y borrados"
          }
        }
      }
    },
    "maintenance": {
      "service_whichever_first": {
        "title": "Revisión: 12 meses o 10.000 millas",
        "description": "Lo que ocurra primero, contado desde la última revisión completada."
      },
      "service_calendar": {
        "title": "Revisión anual",
        "description": "Cada 12 meses desde la última revisión completada."
      },
      "service_mileage": {
        "title": "Revisión cada 10.000 millas",
        "description": "Solo distancia, contada desde la lectura de la última revisión."
      }
    },
    "compliance": {
      "roadworthy": {
        "label": "Inspección técnica del vehículo, como el MOT"
      },
      "insurance": {
        "label": "Seguro del vehículo"
      }
    }
  },
  "equipment": {
    "assetTypes": {
      "0": "Máquina",
      "1": "Herramienta",
      "2": "Equipo de elevación",
      "3": "Carretilla elevadora",
      "4": "Compresor"
    },
    "sample": {
      "name": "Máquina de ejemplo",
      "description": "Una máquina de ejemplo para que pruebe una revisión previa al uso antes de añadir las suyas."
    },
    "templates": {
      "pre_use_check": {
        "name": "Revisión previa al uso",
        "description": "La revisión antes de que el operario empiece a trabajar.",
        "items": {
          "0": {
            "label": "Protecciones y dispositivos de seguridad en su sitio"
          },
          "1": {
            "label": "La parada de emergencia funciona"
          },
          "2": {
            "label": "Sin daños ni fugas visibles"
          },
          "3": {
            "label": "Mandos e indicadores funcionan"
          },
          "4": {
            "label": "Horas de funcionamiento registradas"
          }
        }
      },
      "condition_inspection": {
        "name": "Inspección del estado",
        "description": "Cómo está aguantando la máquina.",
        "groups": {
          "0": {
            "label": "Identificación",
            "guidance": "Muestre la placa de identificación y la etiqueta del activo."
          },
          "1": {
            "label": "Estado exterior",
            "guidance": "Escanee la parte delantera, los laterales y la base del equipo. Incluya las protecciones, las mangueras y las conexiones."
          },
          "2": {
            "label": "Datos de funcionamiento",
            "guidance": "Muestre el horómetro."
          },
          "3": {
            "label": "Prueba de funcionamiento"
          }
        },
        "items": {
          "0": {
            "label": "Número de serie"
          },
          "1": {
            "label": "Estado general"
          },
          "2": {
            "label": "Fugas visibles"
          },
          "3": {
            "label": "Protecciones presentes y bien sujetas"
          },
          "4": {
            "label": "Cables y conectores eléctricos"
          },
          "5": {
            "label": "Hidráulica y neumática"
          },
          "6": {
            "label": "Etiquetas y marcas legibles"
          },
          "7": {
            "label": "Horas de funcionamiento"
          },
          "8": {
            "label": "Desgaste de las piezas móviles"
          },
          "9": {
            "label": "Arranca y funciona correctamente"
          },
          "10": {
            "label": "Sin ruidos ni vibraciones anómalos"
          }
        }
      },
      "maintenance_inspection": {
        "name": "Inspección de mantenimiento",
        "description": "La visita de mantenimiento planificada y lo que encontró.",
        "items": {
          "0": {
            "label": "Horas de funcionamiento o ciclos registrados"
          },
          "1": {
            "label": "Lubricación hecha"
          },
          "2": {
            "label": "Filtros y consumibles sustituidos"
          },
          "3": {
            "label": "Dispositivos de seguridad probados de nuevo"
          },
          "4": {
            "label": "Puesto de nuevo en servicio"
          }
        }
      },
      "calibration_evidence": {
        "name": "Revisión de evidencias de calibración",
        "description": "Si la calibración registrada está vigente y es trazable.",
        "items": {
          "0": {
            "label": "Certificado de calibración archivado"
          },
          "1": {
            "label": "Calibración todavía vigente"
          },
          "2": {
            "label": "Etiqueta de calibración en el equipo"
          },
          "3": {
            "label": "Patrón de referencia trazable"
          }
        }
      }
    },
    "maintenance": {
      "service_operating_hours": {
        "title": "Revisión cada 500 horas de funcionamiento",
        "description": "Contada desde la lectura de horas de la última revisión completada.",
        "programmeTitle": "Programa por horas de funcionamiento"
      },
      "service_operating_hours_major": {
        "title": "Revisión mayor cada 1.000 horas de funcionamiento",
        "description": "La revisión más completa, con el mismo horómetro."
      },
      "service_cycles": {
        "title": "Revisión general cada 2.000 ciclos",
        "description": "Contada desde el recuento de ciclos de la última revisión general completada."
      }
    },
    "compliance": {
      "lifting": {
        "label": "Examen exhaustivo de equipos de elevación"
      },
      "electrical": {
        "label": "Evidencias de seguridad eléctrica, como un registro PAT"
      }
    }
  },
  "facilities": {
    "assetTypes": {
      "0": "Edificio",
      "1": "Climatización",
      "2": "Bomba",
      "3": "Generador",
      "4": "Sistema contra incendios",
      "5": "Distribución eléctrica"
    },
    "sample": {
      "name": "Edificio de ejemplo",
      "description": "Un edificio de ejemplo para que pruebe una inspección antes de añadir los suyos."
    },
    "templates": {
      "planned_maintenance": {
        "name": "Mantenimiento planificado",
        "description": "La visita programada a un equipo de la instalación.",
        "items": {
          "0": {
            "label": "Horas de funcionamiento registradas"
          },
          "1": {
            "label": "Filtros y correas"
          },
          "2": {
            "label": "Fugas, ruidos o vibraciones"
          },
          "3": {
            "label": "Mandos y consignas correctos"
          },
          "4": {
            "label": "Aislamiento y dispositivos de seguridad probados"
          }
        }
      },
      "condition_inspection": {
        "name": "Inspección del estado",
        "description": "Cómo están aguantando el edificio y sus instalaciones.",
        "items": {
          "0": {
            "label": "Envolvente del edificio"
          },
          "1": {
            "label": "Cubierta y drenaje"
          },
          "2": {
            "label": "Instalaciones mecánicas"
          },
          "3": {
            "label": "Distribución eléctrica"
          },
          "4": {
            "label": "Zonas comunes"
          }
        }
      },
      "safety_inspection": {
        "name": "Inspección de seguridad",
        "description": "Lo que tiene que estar bien antes de que haya nadie en el edificio.",
        "items": {
          "0": {
            "label": "Central de alarma de incendios sin incidencias"
          },
          "1": {
            "label": "Vías de evacuación y salidas finales despejadas"
          },
          "2": {
            "label": "Alumbrado de emergencia funciona"
          },
          "3": {
            "label": "Extintores en vigor y en su sitio"
          },
          "4": {
            "label": "Señalización presente y legible"
          }
        }
      },
      "plant_room_check": {
        "name": "Revisión de la sala de máquinas",
        "description": "La revisión rutinaria de la sala de máquinas.",
        "items": {
          "0": {
            "label": "Sala de máquinas cerrada y despejada"
          },
          "1": {
            "label": "Sin fugas ni agua estancada"
          },
          "2": {
            "label": "Presiones y temperaturas dentro del rango"
          },
          "3": {
            "label": "Alarmas e indicadores normales"
          },
          "4": {
            "label": "Ventilación sin obstrucciones"
          }
        }
      },
      "energy_walkround": {
        "name": "Ronda de energía y medio ambiente",
        "description": "Un recorrido por un edificio buscando energía y agua desperdiciadas, y comprobando si se leyeron los contadores.",
        "items": {
          "0": {
            "label": "Contadores leídos este mes"
          },
          "1": {
            "label": "Luces apagadas en zonas vacías"
          },
          "2": {
            "label": "Calefacción y refrigeración a las temperaturas acordadas"
          },
          "3": {
            "label": "Calefacción y refrigeración no funcionan a la vez"
          },
          "4": {
            "label": "Puertas y ventanas cerradas donde hay calefacción o refrigeración"
          },
          "5": {
            "label": "Sin grifos que gotean ni cisternas que pierden"
          },
          "6": {
            "label": "Equipos apagados fuera de horario"
          },
          "7": {
            "label": "Certificado energético expuesto donde es obligatorio"
          }
        }
      },
      "fgas_leak_check": {
        "name": "Control de fugas de gases fluorados",
        "description": "El control periódico de fugas de un equipo con refrigerante fluorado, por un técnico certificado.",
        "items": {
          "0": {
            "label": "Técnico certificado en gases fluorados"
          },
          "1": {
            "label": "Uniones, válvulas y juntas revisadas"
          },
          "2": {
            "label": "Sistema de detección de fugas funcionando (si existe)"
          },
          "3": {
            "label": "Sin restos de aceite en las uniones"
          },
          "4": {
            "label": "Refrigerante añadido (registre los kg en el activo)"
          },
          "5": {
            "label": "Fuga encontrada"
          },
          "6": {
            "label": "La placa indica tipo de refrigerante y carga"
          }
        }
      }
    },
    "maintenance": {
      "ppm_quarterly": {
        "title": "Mantenimiento planificado trimestral",
        "description": "Cada 3 meses desde la última visita completada."
      },
      "generator_hours": {
        "title": "Revisión del generador cada 250 horas de funcionamiento",
        "description": "Contada desde la lectura de horas de la última revisión completada."
      }
    },
    "compliance": {
      "energy_performance": {
        "label": "Certificado de eficiencia energética (EPC)"
      },
      "water_hygiene": {
        "label": "Evidencias de higiene del agua, como una evaluación del riesgo de legionela"
      },
      "fire_safety": {
        "label": "Evidencias de seguridad contra incendios"
      },
      "lifting": {
        "label": "Examen exhaustivo de equipos de elevación"
      },
      "electrical": {
        "label": "Informe del estado de la instalación eléctrica (EICR)"
      }
    }
  }
};
